<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
  <div [ngStyle]="{ padding: '4px' }">
    <mat-icon class="u-margin-2xsmall">waving_hand</mat-icon>
  </div>
  <p>
    {{ text }}
  </p>
</div>
